export default __webpack_public_path__ + "static/designBg-604c72650f06569a7035ca8184d66f08.png";